<template>
  <div class="bottom">
    <div class="bg"></div>
    <div class="bg-white"></div>
    <div class="bottom-nav">
      <ul>
        <li class="home">
          <router-link :to="{name: 'Dashboard'}">
            <font-awesome-icon :icon="['far', 'list-alt']" />
            <span>{{$t('bottomNavigate.home')}}</span>
          </router-link>
        </li>
        <li class="start-process">
          <router-link :to="{name: 'New Client'}">
            <font-awesome-icon :icon="['far', 'play-circle']" />
             <span>{{$t('bottomNavigate.startProcess')}}</span>
          </router-link>
        </li>
        <li class="my-account">
          <router-link to="/my-account">
            <font-awesome-icon :icon="['far', 'user']" />
            <span>{{$t('bottomNavigate.myAccount')}}</span>
          </router-link>
        </li>
        <li class="logout">
          <a @click.prevent="logout">
            <font-awesome-icon :icon="['far', 'arrow-alt-circle-right']" />
            <span>{{$t('bottomNavigate.logOut')}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'BottomNavigation',
  methods: {
    ...mapActions(['logoutAction', 'setMessage']),
    logout() {
      this.logoutAction();
      this.setMessage({ status: 'info', text: this.$i18n.t('general.logout') });
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/variables';

.bottom-nav {
	a {
		color: $primary;
		cursor: pointer;

    // Logout button
		&:not([href]) {
			&:not([tabindex]) {
				color: $primary;
				cursor: pointer;
			}
		}
	}
}
</style>
